import { rangesToXY } from 'nmr-processing';
import { initiateDatum1D } from '../initiateDatum1D';
export function generateSpectrumFromRanges(ranges, info, usedColors) {
    const { nucleus, solvent, name = null, frequency = 400 } = info;
    const { x, y } = rangesToXY(ranges, {
        nucleus,
        frequency,
        nbPoints: 2 ** 17,
    });
    const datum = initiateDatum1D({
        data: { x, im: null, re: y },
        info: {
            nucleus,
            originFrequency: frequency,
            baseFrequency: frequency,
            pulseSequence: '',
            solvent,
            isFt: true,
            name,
        },
        ranges: { values: ranges, options: { sum: 100 } },
    }, { usedColors });
    return datum;
}
